import { Component, ElementRef, OnInit, ViewChild,HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GarageDetailsService } from './garage-details-service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';  
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GlobalVariable } from '../globals';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Rellax from 'rellax';
Swiper.use([Navigation, Pagination, Autoplay]);
// import { SwiperModule } from 'swiper/angular';

@Component({
  selector: 'app-garage-details',
  standalone: true,
  imports: [CommonModule,FormsModule,ReactiveFormsModule,MatIconModule,GoogleMapsModule],
  templateUrl: './garage-details.html',
  styleUrls: ['./garage-details.scss']
})
export class GarageDetails implements OnInit {
  key: any;  
  garageData: any = {
    reviews: [
      { comment: 'Great service!', rating: 5 },
      { comment: 'Very professional.', rating: 4.5 },
      { comment: 'Highly recommend!', rating: 5 },
      { comment: 'Quick and easy!', rating: 4 },
      { comment: 'Excellent!', rating: 5 }
    ]
  };

  visibleReviews: any[] = [];
  currentIndex = 0;           
  slidesToShow = 3;
  coupons: any[] = [];
  selectedCoupon: any = null;
  callbackForm: FormGroup;
  userId = GlobalVariable.userId;
  private scrollInterval: any;
  safeButtonLink!: SafeResourceUrl;
  safeMapUrl!: SafeResourceUrl;
  successMessage: string = '';
  couponForm: FormGroup;
  isPrevDisabled = true;
  isNextDisabled = false;
  services: any;
  // swiperInstance!: Swiper;
  showQuickBookBtn = false;
  isModalOpen = false;
  swiperInstance: any;
  showCta = false;
  showRequestBtn = false;
  isPageLoading = true;       
  isCouponsLoading = false;   
  isSubmitting = false;  
  isNavbarWhite = false;
  showIssueDropdown = true;
  fromServicePage = false; 
  selectedServiceKey = ''; 
  categories: any[] = [];
  subCategoriesMap: { [key: string]: any[] } = {};
  isCategoryLoading = false;
  showQuickBooking = false;
  // Google maps Integration
  center: any;
  zoom: number = 14;
  marker: any;
  submitted = false;
  mapOptions: google.maps.MapOptions = {
  disableDefaultUI: true,
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: true,
  
};
  // End Google maps Integration

  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  @ViewChild('markerElem', { static: false }) markerElem!: MapMarker;
  @ViewChild('slide1') slide1!: ElementRef;
  @ViewChild('slide2') slide2!: ElementRef;
  @ViewChild('slide3') slide3!: ElementRef;
  @ViewChild('heroSwiper', { static: false }) heroSwiper!: ElementRef;
  @ViewChild('heroSection', { static: true }) heroSection!: ElementRef;
  @ViewChild('contactUs', { static: true }) contactUs!: ElementRef;
  @ViewChild('bookBtn') bookBtn!: ElementRef;
 

  constructor(
    private garageService: GarageDetailsService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {this.callbackForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      registrationNumber: ['',     Validators.pattern('^[A-Z]{2}\\s?[0-9]{2}\\s?[A-Z]{2}\\s?[0-9]{4}$')],
      issue: [null, Validators.required] 
    });
    this.couponForm = this.fb.group({
    couponName: ['', Validators.required],
    couponMobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
    couponIssue: ['']
  });
  }

  ngOnInit(): void {
    this.key = this.resolveGarageKey();
        
      this.route.paramMap.subscribe(params => {
        this.key = params.get('key') || '';
      });
      localStorage.setItem('garageKey', this.key);
      localStorage.removeItem('vehicleData');
      localStorage.removeItem('serviceId');
      this.loadGarageDetails();
      this.loadCoupons();
      this.startAutoScroll();
      this.loadCategoriesAndSubCategories();
  }


ngAfterViewInit(): void {

  const testimonialSwiper = new Swiper('.testimonial-swiper', {
    slidesPerView: 1,
    // loop: true,
    rewind: true,
    pagination: {
      el: '.swiper-pagination-testimonial',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-new',
      prevEl: '.swiper-button-prev-new',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  // Makes / Cars Logos Swiper
 const makesSwiper = new Swiper('.makes-swiper-container', {
  slidesPerView: 1,
  loop: false,
  rewind: false,
  autoplay: false,

  navigation: {
    nextEl: '.swiper-button-next-makes',
    prevEl: '.swiper-button-prev-makes',
  },

  observer: true,
  observeParents: true,
});


   // 🔹 HERO SWIPER (ADD ONLY)
  const heroSwiper = new Swiper('.hero-swiper', {
  slidesPerView: 1,
  loop: true,

  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },

  pagination: {
    el: '.swiper-pagination-hero',
    clickable: true,
  },

  observer: true,
  observeParents: true,
});



  // 🔹 HERO BUTTONS
  const heroNext = document.querySelector(
    '.hero-wrapper .swiper-button-next'
  ) as HTMLElement;

  const heroPrev = document.querySelector(
    '.hero-wrapper .swiper-button-prev'
  ) as HTMLElement;

  heroNext?.addEventListener('click', () => {
    heroSwiper.slideNext();
  });

  heroPrev?.addEventListener('click', () => {
    heroSwiper.slidePrev();
  });

  // Optional: update after init
  setTimeout(() => {
    testimonialSwiper.update();
    // makesSwiper.update();
  }, 300);

   const bookBtn = document.querySelector('.requestBtn-new') as HTMLElement;
  if (bookBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // entry.isIntersecting is true when button is in view
        this.showQuickBooking = !entry.isIntersecting;
      },
      {
        root: null, // viewport
        threshold: 0.1, // 10% visible
      }
    );

    observer.observe(bookBtn);
  }
const shouldScroll = sessionStorage.getItem('scrollToServices');

  if (shouldScroll === 'true') {

    setTimeout(() => {
      const element = document.getElementById('our-services');

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }

      // remove flag so refresh won't scroll
      sessionStorage.removeItem('scrollToServices');

    }, 100);

  }
}

// ngAfterViewInit(): void {

//   // 🔹 OLD SWIPER (KEEP AS-IS)
//   this.swiperInstance = new Swiper('.swiper', {
//     slidesPerView: 1,
//     rewind: true,
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     navigation: {
//       nextEl: '.swiper-button-next-new',
//       prevEl: '.swiper-button-prev-new',
//     },
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     },
//   });

//   // 🔹 HERO SWIPER (ADD ONLY)
//   const heroSwiper = new Swiper('.hero-swiper', {
//     slidesPerView: 1,
//     loop: true,
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     },
//   });

//   // 🔹 HERO BUTTONS
//   const heroNext = document.querySelector(
//     '.hero-wrapper .swiper-button-next'
//   ) as HTMLElement;

//   const heroPrev = document.querySelector(
//     '.hero-wrapper .swiper-button-prev'
//   ) as HTMLElement;

//   heroNext?.addEventListener('click', () => {
//     heroSwiper.slideNext();
//   });

//   heroPrev?.addEventListener('click', () => {
//     heroSwiper.slidePrev();
//   });
//    setTimeout(() => {
//     if (this.swiperInstance) {
//       this.swiperInstance.allowTouchMove = true;
//       this.swiperInstance.params.touchStartPreventDefault = false;
//       this.swiperInstance.update();
//     }
//   }, 300);
// }

@HostListener('window:scroll', [])
onWindowScroll() {
  const aboutSection = document.getElementById('About-us');

  if (!aboutSection) return;

  const rect = aboutSection.getBoundingClientRect();

  // When About-us touches the top of viewport
  const isAfterFirstSection = rect.top <= 0;

  this.showRequestBtn = isAfterFirstSection;
  this.isNavbarWhite = isAfterFirstSection;
  if (!this.contactUs) return;

  const heroBottom =
    this.contactUs.nativeElement.getBoundingClientRect().bottom;

  // Show button only when hero is out of view
  this.showQuickBookBtn = heroBottom <= 0;
}


//   @HostListener('window:scroll', [])
// onWindowScroll() {
//     const aboutSection = document.getElementById('About-us');

//     if (aboutSection) {
//       const rect = aboutSection.getBoundingClientRect();
//       // Show the button when About-us section has scrolled out of view
//       this.showRequestBtn = rect.top <= 0;
//     }
//   }

  initCounters() {
    const counters = document.querySelectorAll('.counter');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target as HTMLElement;
          const target = parseInt(el.innerText.replace(/\D/g, ''), 10);
          let count = 0;
          const step = Math.ceil(target / 60);

          const interval = setInterval(() => {
            count += step;
            if (count >= target) {
              el.innerText = el.innerText.includes('%')
                ? target + '%'
                : target + '+';
              clearInterval(interval);
            } else {
              el.innerText = count.toString();
            }
          }, 20);

          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
  }

loadGarageDetails() {
   this.isPageLoading = true;
  this.garageService.getGarageDetails(this.key).subscribe({
    next: (res) => {
      if (res.code === 200 && res.data) {
        this.garageData = res.data;
        
        //  garage logo
        if (this.garageData.garageLogo) {
          const logos = this.garageData.garageLogo
            .split(',')
            .map((l: string) => l.trim())
            .filter(Boolean);

         this.garageData.primaryLogo = this.garageData?.garageLogo
          ? this.garageData.garageLogo.split(',')[0].trim()
          : 'assets/img/logos/autoverse-logo-with-text.jpg';
        } else {
          this.garageData.primaryLogo = 'assets/img/logos/autoverse-logo-with-text.jpg';
        }
         if (this.garageData.insuranceUrl) {
          this.garageData.insuranceUrls = this.garageData.insuranceUrl.split(',').filter((url: any) => url);
         }
          // Google maps Integration
          this.center = { lat: this.garageData?.latitude, lng: this.garageData?.longitude }; 
          this.marker = {
            position: { lat: this.garageData?.latitude, lng: this.garageData?.longitude },
            title: this.garageData?.name,
            options: { 
              animation: google.maps.Animation.DROP,
              icon: {
                url: './assets/img/google_map_icon.png',
                scaledSize: new google.maps.Size(30, 30)
              }
            },
            googleRatings: this.garageData?.googleRatings,
            googleReviewNumbers: this.garageData?.googleReviewNumbers,
            address: this.garageData?.address,
            mobileNumber: this.garageData?.mobileNumber
          };
          // Google maps Integration
        
      
        // populate visibleReviews for first time
        // this.updateVisibleReviews();
        // wait a tick to ensure marker is ready
setTimeout(() => {
  if (this.markerElem) {
    this.infoWindow.open(this.markerElem);
  }
}, 500);

      }
       this.isPageLoading = false;
    },
    error: (err) => console.error(err)
  });
}


  /** 🔹 Coupons API */
  loadCoupons() {
    this.garageService.getCoupons(this.key).subscribe({
      next: (res) => {
        if (res.code === 200 && res.data) {
          this.coupons = res.data;
          console.warn('coupon-response', res);
        } else {
          console.warn('No coupons available:', res.message);
        }
      },
      error: (err) => console.error('Error fetching coupons:', err)
    });
  }

  /** Modal functions */
  openModal(coupon: any) {
  this.selectedCoupon = coupon;
  this.isModalOpen = true;
  console.log("Selected coupon:", coupon);
}


  closeModal() {
    this.selectedCoupon = null;
     this.isModalOpen = false;
  }


  getStars(rating: number): string[] {
    const stars: string[] = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) stars.push('full');
    if (hasHalf) stars.push('half');
    while (stars.length < 5) stars.push('empty');

    return stars;
  }

  applyCoupon(coupon: any) {
      this.selectedCoupon = coupon;
    console.log('Applying coupon:', coupon);
    // Later you can call your service here if needed
    // this.closeModal();
  }
  decodeEntities(str: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }
  // openRequestModal() {
  //   this.isModalOpen = true;
    
  //   const modalEl = document.getElementById('requestCallBackModal');
  //   if (modalEl) {
  //     const modal = new (window as any).bootstrap.Modal(modalEl, {
  //       backdrop: false
  //     });
  //     modal.show();
  //   }
  // }

  openRequestModal() {
  this.isModalOpen = true;

  // ✅ Close Offcanvas Navbar if open
  const offcanvasEl = document.querySelector('.offcanvas-nav');
  if (offcanvasEl) {
    const offcanvasInstance =
      (window as any).bootstrap.Offcanvas.getInstance(offcanvasEl);

    if (offcanvasInstance) {
      offcanvasInstance.hide();
    }
  }

  // ✅ Open Modal
  const modalEl = document.getElementById('requestCallBackModal');
  if (modalEl) {
    const modal = new (window as any).bootstrap.Modal(modalEl, {
      backdrop: false
    });

    modal.show();

    modalEl.addEventListener('hidden.bs.modal', () => {
      this.isModalOpen = false;
    });
  }
}


//   openRequestModal() {

//   // ⏸️ STOP swiper immediately (stops the 5s timer)
//   if (this.swiperInstance?.autoplay) {
//     this.swiperInstance.autoplay.stop();
//   }

//   const modalEl = document.getElementById('requestCallBackModal');
//   if (modalEl) {
//     const modal = new (window as any).bootstrap.Modal(modalEl, {
//       backdrop: false
//     });

//     modal.show();

//     // ▶️ OPTIONAL: Resume only after modal is closed
//     modalEl.addEventListener('hidden.bs.modal', () => {
//       this.swiperInstance?.autoplay.start();
//     }, { once: true });
//   }
// }

//   submitForm() {

//   if (this.callbackForm.invalid) {
//     this.callbackForm.markAllAsTouched(); // 🔥 THIS IS MANDATORY
//     return;
//   }

//   const { name, mobile, issue } = this.callbackForm.value;

//   const payload = {
//     garageKey: this.key,
//     userId: this.userId,
//     name,
//     phoneNumber: mobile,
//     issue,
//     couponId: this.selectedCoupon?.couponId || null,
//     tagDeal: this.selectedCoupon?.tagDeal || null,
//     tag: this.selectedCoupon?.tag || null,
//     discount: this.selectedCoupon?.discount || null,
//     validTill: this.selectedCoupon?.validTill || null,
//     description: this.selectedCoupon?.description || null,
//     couponCode: this.selectedCoupon?.couponCode || null,
//   };

//   // rest of your API logic stays SAME
// }
  submitForm() {
      this.submitted = true;
    if (this.callbackForm.invalid){
      this.callbackForm.markAllAsTouched(); 
      return;
    }
    this.isSubmitting = true;
    const { name, mobile, registrationNumber ,issue } = this.callbackForm.value;

    const payload = {
      garageKey: this.key,
      userId: this.userId,
      name,
      phoneNumber: mobile,
      registrationNumber,
      issue: issue?.label,
      couponId: this.selectedCoupon?.couponId || null,
      tagDeal: this.selectedCoupon?.tagDeal || null,
      tag: this.selectedCoupon?.tag || null,
      discount: this.selectedCoupon?.discount || null,
      validTill: this.selectedCoupon?.validTill || null,
      description: this.selectedCoupon?.description || null,
      couponCode: this.selectedCoupon?.couponCode || null,
    };

    this.garageService.createBooking(payload).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        if (res.code === 200) {
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          // ✅ hide the request callback modal first
          const requestModalEl = document.getElementById('requestCallBackModal');
          const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
          requestModal?.hide();
          this.isModalOpen = false;

          // ✅ wait a tick before showing success modal
          setTimeout(() => {
            const successModalEl = document.getElementById('successModal');
            if (successModalEl) {
              const successModal = new (window as any).bootstrap.Modal(successModalEl);
              successModal.show();
            }
          }, 200);

          // reset form
          this.callbackForm.reset();
          this.selectedCoupon = null;
          
          this.showIssueDropdown = !this.fromServicePage;
        } else {
          alert('Something went wrong. Please try again.');
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        console.error('Error creating booking:', err);
        alert('Error creating booking. Please try again.');
      }
    });
  }
  closeSuccessModal() {
    const successModalEl = document.getElementById('successModal');
    const successModal = (window as any).bootstrap.Modal.getInstance(successModalEl);
    successModal?.hide();

    // reload page or perform other actions
    location.reload();
  }
  applyCouponForm() {
    if (this.couponForm.invalid) {
      this.couponForm.markAllAsTouched(); 
      alert("Please enter Full Name and Mobile Number");
      return;
    }

    const { couponName, couponMobile, couponIssue } = this.couponForm.value;

    const payload = {
      garageKey: this.key,
      userId: this.userId,
      name: couponName,
      phoneNumber: couponMobile,
      issue: couponIssue,
      couponId: this.selectedCoupon?.couponId || null,
      tagDeal: this.selectedCoupon?.tagDeal || null,
      tag: this.selectedCoupon?.tag || null,
      discount: this.selectedCoupon?.discount || null,
      validTill: this.selectedCoupon?.validTill || null,
      description: this.selectedCoupon?.description || null,
      couponCode: this.selectedCoupon?.couponCode || null,
    };

    this.garageService.createBooking(payload).subscribe({
      next: (res) => {
        if (res.code === 200) {
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          // const couponModalEl = document.getElementById('couponModal');
          // if (couponModalEl) couponModalEl.style.display = 'none';

          this.selectedCoupon = null;
          this.isModalOpen = false;
          const successModalEl = document.getElementById('successModal');
          if (successModalEl) {
            const successModal = new (window as any).bootstrap.Modal(successModalEl);
            successModal.show();
          }

          this.couponForm.reset();
          this.selectedCoupon = null;
        } else {
          alert("Error creating booking. Please try again.");
        }
      },
      error: (err) => {
        console.error("Error:", err);
        alert("Error creating booking. Please try again.");
      }
    });
  }

  prevSlide() {
    if (this.isPrevDisabled) return;
    this.currentIndex = Math.max(0, this.currentIndex - this.slidesToShow);
    this.updateVisibleReviews();
  }

  nextSlide() {
    if (this.isNextDisabled) return;
    this.currentIndex = Math.min(
      (this.garageData?.reviews?.length || 0) - this.slidesToShow,
      this.currentIndex + this.slidesToShow
    );
    this.updateVisibleReviews();
  }

  updateVisibleReviews() {
    this.visibleReviews = this.garageData?.reviews.slice(this.currentIndex, this.currentIndex + this.slidesToShow) || [];
  }
  ngOnDestroy() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
      }
    }

    startAutoScroll() {
      const container = document.querySelector('.insurance-logos') as HTMLElement;
      if (!container) return;

      this.scrollInterval = setInterval(() => {
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
          container.scrollTo({ left: 0, behavior: 'auto' });
        } else {
          container.scrollBy({ left: 1, behavior: 'smooth' });
        }
      }, 20);
    }

  scrollRight() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    if (container) {
      container.scrollBy({ left: 400, behavior: 'smooth' });
      setTimeout(() => this.checkButtons(container), 400);
    }
  }

  scrollLeft() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    if (container) {
      container.scrollBy({ left: -400, behavior: 'smooth' });
      setTimeout(() => this.checkButtons(container), 400);
    }
  }

  checkButtons(container: HTMLElement) {
    this.isPrevDisabled = container.scrollLeft <= 0;
    this.isNextDisabled =
      container.scrollLeft + container.clientWidth >= container.scrollWidth;
  }
  scrollReviewsRight() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    const card = container?.querySelector('.review-card') as HTMLElement;
    if (container && card) {
      container.scrollBy({ left: card.offsetWidth + 20, behavior: 'smooth' });
    }
  }

  scrollReviewsLeft() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    const card = container?.querySelector('.review-card') as HTMLElement;
    if (container && card) {
      container.scrollBy({ left: -(card.offsetWidth + 20), behavior: 'smooth' });
    }
  }

    scrollLeftMake() {
    const container = document.querySelector('.makes-container') as HTMLElement;
    if (container) {
      container.scrollBy({ left: -300, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(container), 400);
    }
  }

  scrollRightMake() {
    const container = document.querySelector('.makes-container') as HTMLElement;
    if (container) {
      container.scrollBy({ left: 300, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(container), 400);
    }
  }
  checkScrollButtons(container: HTMLElement) {
    this.isPrevDisabled = container.scrollLeft <= 0;
    this.isNextDisabled =
      container.scrollLeft + container.clientWidth >= container.scrollWidth;
  }
  goToRegistrationDecode() {
    this.router.navigate(['registration-decode']);
  }

  // Google maps Integration
  get directionsLink() {
    return `https://www.google.com/maps/dir/?api=1&destination=${this.garageData?.latitude},${this.garageData?.longitude}`;
  }

  get largerMapLink() {
    return `https://www.google.com/maps/search/?api=1&query=${this.garageData?.latitude},${this.garageData?.longitude}`;
  }

  openInfo(marker: MapMarker) {
    this.infoWindow.open(marker);
  }
  // End Google maps Integration

// scrollTo(id: string) {
//   document.getElementById(id)
//     ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

//   const openDropdown = document.querySelector('.dropdown-menu.show');
//   openDropdown?.classList.remove('show');
// }
scrollTo(id: string) {
  // 1️⃣ Scroll to section
  document.getElementById(id)
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  // 2️⃣ Close open dropdown (if any)
  const openDropdown = document.querySelector('.dropdown-menu.show');
  openDropdown?.classList.remove('show');

  // 3️⃣ Close hamburger sidebar (offcanvas)
  const offcanvasEl = document.querySelector('.offcanvas-nav');
  if (offcanvasEl) {
    (window as any).bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
  }
}
 onCtaClick() {
    // Scroll to any section or open modal
    const target = document.getElementById('our-services');
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
heroPrev() {
  this.swiperInstance?.autoplay.stop();
  this.swiperInstance?.slidePrev();
}

heroNext() {
  this.swiperInstance?.autoplay.stop();
  this.swiperInstance?.slideNext();
}
private resolveGarageKey(): string | null {
  return (
    this.route.snapshot.paramMap.get('key') ||
    localStorage.getItem('garageKey')
  );
}
// goToPeriodicpage() {
//   localStorage.removeItem("serviceId");
//   this.router.navigate(['/periodic-service-details'], { queryParams: { categoryId: 2 } });
// }
// goToSteeringpage() {
//   this.router.navigate(['/steering-issue-details']);
// }
// goToTyrepage() {
//   this.router.navigate(['/tyre-issue-details']);
// }
// goToAcpage() {
//   this.router.navigate(['/ac-not-colling-details']);
// }
// goTobrakepage() {
//   this.router.navigate(['/brake-noise-details.html']);
// }
// goTocarpage() {
//   this.router.navigate(['/car-not-starting-details']);
// }
// goTodentingpage() {
//   // this.router.navigate(['/denting-and-painting-details']);
//   localStorage.removeItem("serviceId");
//   this.router.navigate(['/denting-and-painting-details'], { queryParams: { categoryId: 9 } });
// }
// goTonoisepage() {
//   this.router.navigate(['/engine-noise-details.html']);
// }
goToPeriodicpage() {
  localStorage.removeItem("serviceId");
  this.router.navigate(['/estimate-list']);
}
goToEstimateList(){
  this.router.navigate(['/estimate-list']);
}
goToSteeringpage() {
  this.router.navigate(['/estimate-list']);
}
goToTyrepage() {
  this.router.navigate(['/estimate-list']);
}
goToAcpage() {
  this.router.navigate(['/estimate-list']);
}
goTobrakepage() {
  this.router.navigate(['/estimate-list']);
}
goTocarpage() {
  this.router.navigate(['/estimate-list']);
}
goTodentingpage() {
  // this.router.navigate(['/denting-and-painting-details']);
  // localStorage.removeItem("serviceId");
  this.router.navigate(['/estimate-list']);
}
goTonoisepage() {
  this.router.navigate(['/estimate-list']);
}
loadCategoriesAndSubCategories() {
  this.isCategoryLoading = true;

  this.garageService.getCategoriesAndSubCategories().subscribe({
    next: (res) => {
      if (res.code === 200 && res.data) {

        // Full category list
        this.categories = res.data.categories || [];

        // Map categories to 'services' dropdown
        this.services = this.categories.map((cat: any) => ({
          key: cat.id,      // category ID will be the value
          label: cat.name   // category name will be the label
        }));

        // Create a map of subcategories by category ID
        this.subCategoriesMap = {};
        const subCategories = res.data.subCategories || [];
        this.categories.forEach((cat: any) => {
          const subcats = subCategories.filter(
            (sub: any) => sub.categoryId === cat.id && sub.name
          );
          if (subcats.length) {
            this.subCategoriesMap[cat.id] = subcats;
          }
        });

        console.log('Services for Dropdown:', this.services);
        console.log('SubCategories Map:', this.subCategoriesMap);
      }

      this.isCategoryLoading = false;
    },
    error: (err) => {
      console.error('Error loading categories', err);
      this.isCategoryLoading = false;
    }
  });
}
goToInsuranceClaimDetails() {
  this.router.navigate(['/insurance-claim']);
}
    formatRegistrationNumber() {
  let value = this.callbackForm.get('registrationNumber')?.value || '';

  value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (value.length > 2) value = value.slice(0, 2) + ' ' + value.slice(2);
  if (value.length > 5) value = value.slice(0, 5) + ' ' + value.slice(5);
  if (value.length > 8) value = value.slice(0, 8) + ' ' + value.slice(8, 12);

  this.callbackForm.get('registrationNumber')?.setValue(value, { emitEvent: false });
}
}
